import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-proactive-support }}\n{{yield}}",{ moduleName: "embercom/components/series/node/connectors/yield-area.hbs" })